import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import Loader from './../../UI/Loader'

import ActivitySummary from '../ActivitySummary'

class FinishPage extends Component {
  render() {
    if (this.props.loading) {
      return <Loader showLoader={true} />
    }

    return <ActivitySummary summary={this.props.summary} extraClass="activity-summary__centered finish-page faded-container" />
  }
}

const enhance = compose(translate('activity_steps'))

export default enhance(FinishPage)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/FinishPage.jsx